export default __webpack_public_path__ + "static/media/100007.9f6ed60f.jpg";